"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SubMenuWithIframe = _interopRequireDefault(require("./SubMenuWithIframe.render"));
var _getAppConfig = require("../../constants/getAppConfig");
var _isJson = require("../Nav/Desktop/NavItem/Functionality/ActivityFeed/utils/isJson");
var _sharedHeaderContract = require("@icis/shared-header-contract");
const SubMenuWithIframeIntelligencePages = _ref => {
  var _getConfig$urls;
  let {
    showing,
    width,
    height,
    isMobile,
    hasHeader
  } = _ref;
  const ref = (0, _react.useRef)((_getConfig$urls = (0, _getAppConfig.getConfig)().urls) === null || _getConfig$urls === void 0 ? void 0 : _getConfig$urls.intelligencePagesNavUrl);
  (0, _react.useEffect)(() => {
    (0, _sharedHeaderContract.initContract)(ref.current);
    function onMessageReceive(event) {
      const domain = new URL(ref.current);
      if (event.origin === domain.origin && (0, _isJson.isJsonString)(event.data)) {
        const {
          type,
          data: messageData
        } = JSON.parse(event.data);
        if (type === 'CANVAS_OPEN_URL_SELF') {
          window.open(messageData.url, '_self');
        }
      }
    }
    window.addEventListener('message', onMessageReceive);
    return () => {
      window.removeEventListener('message', onMessageReceive);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_SubMenuWithIframe.default, {
    testId: "IntelligencePages-Skeleton",
    showing: showing,
    iframeTitle: "intelligencePages",
    url: ref.current,
    width: width,
    height: height,
    isMobile: isMobile,
    hasHeader: hasHeader,
    isTopicsMenu: true
  });
};
var _default = exports.default = SubMenuWithIframeIntelligencePages;